import { useState } from "react";

export default function RouteRefundModal({ status, onClose, onConfirm }: { status: string; onClose: () => void; onConfirm: () => void }) {
  const isFree = status === "待成团";
  const refundInfo = isFree
    ? { rate: "100%", deduct: 0, refund: 3600, total: 3600 }
    : { rate: "70%", deduct: 1080, refund: 2520, total: 3600 };
  const [confirmed, setConfirmed] = useState(false);
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const handleConfirm = () => {
    setLoading(true);
    setTimeout(() => { setLoading(false); setDone(true); setTimeout(() => onConfirm(), 1500); }, 1200);
  };
  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center" style={{ background: "rgba(0,0,0,0.5)", backdropFilter: "blur(4px)" }}>
      <div className="bg-white rounded-t-3xl w-full" style={{ maxWidth: 480 }}>
        <div className="w-10 h-1 rounded-full bg-gray-200 mx-auto mt-3" />
        <div className="flex items-center justify-between px-5 pt-4 pb-3" style={{ borderBottom: "1px solid #F5F5F5" }}>
          <button onClick={onClose} className="w-8 h-8 flex items-center justify-center rounded-full cursor-pointer" style={{ background: "#F4F5F9" }}><i className="ri-close-line" style={{ color: "#374151", fontSize: 18 }} /></button>
          <span className="text-base font-bold text-gray-900">取消线路</span>
          <div className="w-8" />
        </div>
        <div className="px-5 py-5">
          {done ? (
            <div className="flex flex-col items-center py-6">
              <div className="w-16 h-16 rounded-full flex items-center justify-center mb-3" style={{ background: "#ECFDF5" }}><i className="ri-checkbox-circle-fill" style={{ color: "#10B981", fontSize: 36 }} /></div>
              <div className="text-base font-bold text-gray-900 mb-1">取消申请已提交</div>
              <div className="text-xs text-gray-500 text-center">退款 ¥{refundInfo.refund.toLocaleString()} 将在3-5个工作日内原路返回</div>
            </div>
          ) : (
            <>
              {isFree ? (
                <div className="mb-4 p-4 rounded-2xl flex items-start gap-3" style={{ background: "#ECFDF5", border: "1px solid #A7F3D0" }}>
                  <i className="ri-checkbox-circle-line flex-shrink-0 mt-0.5" style={{ color: "#059669", fontSize: 20 }} />
                  <div><div className="text-sm font-semibold text-green-800 mb-1">可无责取消 · 全额退款</div><div className="text-xs text-green-700 leading-relaxed">线路尚未成团，取消订单将全额退款，不扣任何费用。</div></div>
                </div>
              ) : (
                <div className="mb-4 p-4 rounded-2xl" style={{ background: "#FFF7ED", border: "1px solid #FED7AA" }}>
                  <div className="flex items-center gap-2 mb-2"><i className="ri-error-warning-line" style={{ color: "#EA580C", fontSize: 16 }} /><span className="text-sm font-semibold" style={{ color: "#EA580C" }}>线路已成团，取消将扣手续费</span></div>
                  <div className="text-xs text-orange-700 leading-relaxed">根据退改政策，出发前3~7天取消退款70%，手续费30%。</div>
                </div>
              )}
              <div className="p-4 rounded-2xl mb-4" style={{ background: "#F8F8F8" }}>
                <div className="text-xs font-semibold text-gray-500 mb-3">退款明细</div>
                <div className="flex justify-between text-xs mb-2"><span className="text-gray-400">订单金额</span><span className="text-gray-700 font-medium">¥{refundInfo.total.toLocaleString()}</span></div>
                <div className="flex justify-between text-xs mb-2"><span className="text-gray-400">退款比例</span><span className="text-gray-700 font-medium">{refundInfo.rate}</span></div>
                {refundInfo.deduct > 0 && <div className="flex justify-between text-xs mb-2"><span className="text-gray-400">扣除手续费</span><span className="font-medium" style={{ color: "#EF4444" }}>-¥{refundInfo.deduct.toLocaleString()}</span></div>}
                <div className="flex justify-between text-sm pt-2" style={{ borderTop: "1px solid #EBEBEB" }}>
                  <span className="font-bold text-gray-900">可退金额</span>
                  <span className="font-bold text-lg" style={{ color: "#059669" }}>¥{refundInfo.refund.toLocaleString()}</span>
                </div>
              </div>
              <button onClick={() => setConfirmed(!confirmed)} className="flex items-center gap-3 cursor-pointer mb-5 w-full text-left">
                <div className="w-5 h-5 rounded-md flex items-center justify-center flex-shrink-0 transition-all" style={{ background: confirmed ? "#EF4444" : "transparent", border: `2px solid ${confirmed ? "#EF4444" : "#D8DAE0"}` }}>
                  {confirmed && <i className="ri-check-line text-white" style={{ fontSize: 11 }} />}
                </div>
                <span className="text-xs text-gray-500">我已了解退款规则，确认取消此线路订单</span>
              </button>
              <div className="flex gap-3">
                <button onClick={onClose} className="flex-1 py-3 rounded-full text-sm font-semibold cursor-pointer whitespace-nowrap" style={{ background: "#F4F5F9", color: "#6B7280" }}>再想想</button>
                <button onClick={handleConfirm} disabled={!confirmed || loading} className="flex-1 py-3 rounded-full text-sm font-semibold cursor-pointer whitespace-nowrap" style={{ background: confirmed ? "#EF4444" : "#F0F0F0", color: confirmed ? "#fff" : "#9CA3AF" }}>
                  {loading ? <span className="flex items-center justify-center gap-1.5"><i className="ri-loader-4-line animate-spin" />处理中</span> : "确认取消"}
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
